/** @jsx jsx */
// import { jsx } from "theme-ui";

const PostsFooter: React.FC = () => null;

export default PostsFooter;
